// extracted by mini-css-extract-plugin
module.exports = {"container":"__500_container__VBd9o","image":"__500_image__zx2CK"};